import React, { useState, useRef, useEffect } from 'react'

import useFetchData from 'hooks/fetch-data'
import Drawer from '@material-ui/core/Drawer'
import enums from 'Constants/enums'
import AddIcon from '@material-ui/icons/Add'
import { useTheme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'

import { FormTitle, FormAccordian } from 'components/Maintainance/components'
import { MinimalInput, MinimalTextArea, MinimalAutoComplete } from 'components/Assets/components'
import { MinimalButton, MinimalButtonGroup, FloatingButton } from 'components/common/buttons'
import { PopupModal } from 'components/common/others'

import { snakifyKeys, camelizeKeys } from 'helpers/formatters'
import { get, isEmpty } from 'lodash'
import { priorityOptions, typeOptions, validate, createPayload } from './utlis'
import { AssetImage, AssetImageUploadButton, necVoilationOptions, nfpa70bOption, oshaVoilationOptions, resolvedOptions, severityCriteriaOptions, thermalAnomalySubComponentOptions, thermalClassificationOptions, UltrasonicAnomalyOptions } from 'components/WorkOrders/onboarding/utils'
import { Toast } from 'Snackbar/useToast'

import issues from 'Services/issues'
import { MAX_IMG_UPLOAD } from 'components/Assets/tree/constants'

const useStyles = makeStyles({
  table: {
    borderRadius: '5px',
    marginBottom: '10px',
    '& th': {
      fontWeight: 'bold',
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: '10px 8px 5px 10px',
    },
    '& td': {
      border: '1px solid rgba(224, 224, 224, 1)',
      textAlign: 'center',
      padding: '10px 0px 0px 10px',
    },
  },
})

const Edit = ({ open, onClose, obj, afterSubmit, isEdit, isForMaintenance, install = () => {}, workOrderID, tempAsset = {}, allDropDownData = [] }) => {
  const classes = useStyles()
  const title = isEdit ? 'Edit Issue' : 'Create Issue'
  const [error, setError] = useState({})
  const [isProcessing, setIsProcessing] = useState('')
  const [issue, setIssue] = useState({ issueDescription: '', backOfficeNote: '', priority: priorityOptions[0].value, issueType: null, issueStatus: enums.ISSUE.STATUS.OPEN, issueImageList: [], asset: null })
  const uploadPhotosRef = useRef(null)
  const [isPhotoUploading, setPhotoUploading] = useState(false)
  const [reason, setReason] = useState('')
  const [isResolveOpen, setResolvedOpen] = useState(false)
  const [issueDetails, setIssueDetails] = useState([])

  // const { loading, data: assetOptions } = useFetchData({ fetch: getAllAssetForTree, payload: {}, formatter: d => formatOptions(camelizeKeys(d)), defaultValue: [] })
  const formatAssetOptions = d => {
    if (isForMaintenance) {
      const mainList = get(d, 'data.mainAssets', []).map(d => ({ ...d, label: d.assetName, value: d.assetId }))
      const tempList = get(d, 'data.tempAssets', []).map(d => ({ ...d, label: d.assetName, value: d.woonboardingassetsId, isTemp: true }))
      return [...tempList, ...mainList]
    } else {
      const data = get(d, 'data.list', []) || []
      const options = data.map(d => ({ ...d, label: d.name, value: d.assetId }))
      return options
      // return get(d, 'data', []).map(d => ({ ...d, label: d.name, value: d.assetId }))
    }
  }

  const request = { pagesize: 0, pageindex: 0, site_id: [], status: 1, asset_id: [], internal_asset_id: [], model_name: [], model_year: [], show_open_issues: 0, search_string: null, option_search_string: null, company_id: [] }

  const { loading, data: assetOptions } = useFetchData({ fetch: isForMaintenance ? issues.getAssetList : issues.getAssetListOptions, payload: isForMaintenance ? { woId: workOrderID } : request, formatter: d => formatAssetOptions(camelizeKeys(d)), defaultValue: [] })

  const [photoErrorType, setPhotoErrorType] = useState('')
  const inspectionTypes = [
    { label: 'Repair', value: enums.MWO_INSPECTION_TYPES.REPAIR },
    { label: 'Replace', value: enums.MWO_INSPECTION_TYPES.REPLACE },
    { label: 'General Issue Resolution', value: enums.MWO_INSPECTION_TYPES.TROUBLE_CALL_CHECK },
  ]
  const theme = useTheme()
  //
  useEffect(() => {
    if (isEdit) {
      const issueTypeValue = get(obj, 'issueType', null)
      let resolvedIssueType = issueTypeValue

      // Reverse the logic to map issueType and issueCausedId back to the correct type
      if (issueTypeValue === enums.ISSUE.TYPE.COMPLIANCE) {
        const issueCausedId = get(obj, 'issueCausedId', null)
        if (issueCausedId === enums.ISSUE.CAUSED.NEC_VIOLATION) {
          resolvedIssueType = enums.ISSUE.TYPE.NEC_VIOLATION
        } else if (issueCausedId === enums.ISSUE.CAUSED.OSHA_VIOLATION) {
          resolvedIssueType = enums.ISSUE.TYPE.OSHA_VIOLATION
        } else if (issueCausedId === enums.ISSUE.CAUSED.NFPA_70B_VIOLATION) {
          resolvedIssueType = enums.ISSUE.TYPE.NFPA_70B_VIOLATION
        }
      }
      const updatedIssue = {
        ...obj,
        issueType: typeOptions.find(d => d.value === resolvedIssueType),
        asset: assetOptions.find(d => d.value === obj.assetId),
      }
      setIssue(updatedIssue)
      setIssueDetails([
        {
          issueTitle: get(obj, 'issueTitle', ''),
          issueType: get(obj, 'issueType', null),
          issueCausedId: get(obj, 'issueCausedId', null),
          necViolation: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NEC_VIOLATION}`, necVoilationOptions)
            .map(v => ({ ...v, value: parseInt(v.value, 0) }))
            .find(d => d.value === get(obj, 'necViolation', null)),
          oshaViolation: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.OSHA_VIOLATION}`, oshaVoilationOptions)
            .map(v => ({ ...v, value: parseInt(v.value, 0) }))
            .find(d => d.value === get(obj, 'oshaViolation', null)),
          nfpa70BViolation: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NFPA70B_VIOLATION}`, nfpa70bOption)
            .map(v => ({ ...v, value: parseInt(v.value, 0) }))
            .find(v => v.value === get(obj, 'nfpa70BViolation', null)),
          thermalAnomalyAdditionalIrPhoto: get(obj, 'thermalAnomalyAdditionalIrPhoto', null),
          thermalAnomalyLocation: get(obj, 'thermalAnomalyLocation', null),
          thermalAnomalyMeasuredAmps: get(obj, 'thermalAnomalyMeasuredAmps', null),
          thermalAnomalyMeasuredTemps: get(obj, 'thermalAnomalyMeasuredTemps', null),
          thermalAnomalyProblemDescription: get(obj, 'thermalAnomalyProblemDescription', null),
          thermalAnomalyCorrectiveAction: get(obj, 'thermalAnomalyCorrectiveAction', null),
          thermalAnomalyRefrenceTemps: get(obj, 'thermalAnomalyRefrenceTemps', null),
          thermalAnomalySubComponant: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.THERMAL_ANAMOLY_SUBCOMPONENT}`, thermalAnomalySubComponentOptions).find(v => v.value === get(obj, 'thermalAnomalySubComponant', null)),
          thermalClassificationId: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.THERMAL_CLASSIFICATION}`, thermalClassificationOptions)
            .map(v => ({ ...v, value: parseInt(v.value, 0) }))
            .find(v => v.value === get(obj, 'thermalClassificationId', null)),
          thermalAnomalySeverityCriteria: get(obj, 'thermalAnomalySeverityCriteria', null),
          typeOfUltrasonicAnamoly: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.ULTRASONIC_ANAMOLY}`, UltrasonicAnomalyOptions)
            .map(v => ({ ...v, value: parseInt(v.value, 0) }))
            .find(v => v.value === get(obj, 'typeOfUltrasonicAnamoly', null)),
          locationOfUltrasonicAnamoly: get(obj, 'locationOfUltrasonicAnamoly', ''),
          sizeOfUltrasonicAnamoly: get(obj, 'sizeOfUltrasonicAnamoly', ''),
          dynamicFieldJson: JSON.parse(get(obj, 'dynamicFieldJson', null)),
          id: 1,
          isAbcPhaseRequiredForReport: get(obj, 'isAbcPhaseRequiredForReport', false),
        },
      ])
    }
  }, [isEdit, obj, typeOptions, assetOptions])

  useEffect(() => {
    if (!isEmpty(tempAsset)) {
      setIssue(prevIssue => ({
        ...prevIssue,
        ...tempAsset,
        asset: assetOptions.find(d => d.value === tempAsset.woonboardingassetsId),
      }))
    }
  }, [tempAsset, assetOptions])

  //
  const handleInputChange = (name, value) => setIssue({ ...issue, [name]: value })
  const handleUpload = type => {
    setError({ ...error, photos: null })
    setPhotoErrorType(type)
    uploadPhotosRef.current && uploadPhotosRef.current.click()
  }

  const addPhoto = e => {
    e.preventDefault()

    const files = Array.from(e.target.files)

    if (files.length > MAX_IMG_UPLOAD) {
      Toast.error(`You can upload up to ${MAX_IMG_UPLOAD} images at a time.`)
      return
    }

    const formData = new FormData()
    let hasImgError = false
    const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'eps', 'heic', 'heif']

    files.forEach((file, index) => {
      const extension = file.name.split('.').slice(-1).pop().toLowerCase()
      if (!validExtensions.includes(extension)) {
        setError({ ...error, photos: { error: true, msg: 'Invalid Image format!' } })
        hasImgError = true
        return
      }
      formData.append('file', file)
      const reader = new FileReader()
      reader.onload = d => {
        if (!hasImgError && index === files.length - 1) {
          setError({ ...error, photos: null })
          uploadPhoto(formData, photoErrorType)
        }
      }
      reader.readAsDataURL(file)
    })
    e.target.value = null
  }

  const uploadPhoto = async (formData, type) => {
    setPhotoUploading(true)
    try {
      const res = await issues.uploadPhoto(formData)
      if (res.success) {
        if (!isEmpty(res.data.imageList)) {
          const imgList = res.data.imageList.map(d => {
            return {
              url: d.fileUrl,
              imageFileNameUrl: d.fileUrl,
              imageFileName: d.filename,
              isDeleted: false,
              imageThumbnailFileNameUrl: d.thumbnailFileUrl,
              imageThumbnailFileName: d.thumbnailFilename,
              assetIssueImageMappingId: get(obj, 'assetIssueImageMappingId', null),
              imageDurationTypeId: type,
            }
          })
          setIssue({ ...issue, issueImageList: [...get(issue, 'issueImageList', []), ...imgList] })
        } else Toast.error(res.message)
      } else Toast.error(res.message)
    } catch (error) {
      Toast.error('Error uploading image !')
    }
    setPhotoUploading(false)
  }
  const removeImage = image => {
    const issueImageList = [...get(issue, 'issueImageList', [])]
    const imageToDelete = issueImageList.find(img => img.imageThumbnailFileName === image.imageThumbnailFileName)
    if (isEmpty(imageToDelete.assetIssueImageMappingId)) {
      const actualIssueImageList = issueImageList.filter(e => e !== imageToDelete)
      setIssue({ ...issue, issueImageList: actualIssueImageList })
    } else {
      imageToDelete.isDeleted = true
      setIssue({ ...issue, issueImageList })
    }
  }
  //validate
  const validateForm = async () => {
    const isValid = await validate({ ...issue, asset: get(issue, 'asset.value', ''), issueType: get(issue, 'issueType.value', ''), resolutionType: get(issue, 'resolutionType.value', '') }, isForMaintenance)
    setError(isValid)

    const flagIssue = [...issueDetails]
    const flagIsseErrors = []
    if (!isEmpty(issueDetails)) {
      flagIssue.forEach(d => {
        const err = {}
        if (isEmpty(d.thermalClassificationId) && d.issueType === enums.ISSUE.TYPE.THERMAL_ANAMOLY) err['thermalClassificationId'] = { error: true, msg: 'Thermal Classification is required !' }
        if (isEmpty(d.necViolation) && d.issueCausedId === enums.ISSUE.CAUSED.NEC_VIOLATION) err['necViolation'] = { error: true, msg: 'Code Violation is required !' }
        if (isEmpty(d.oshaViolation) && d.issueCausedId === enums.ISSUE.CAUSED.OSHA_VIOLATION) err['oshaViolation'] = { error: true, msg: 'Code Violation is required !' }
        if (isEmpty(d.nfpa70BViolation) && d.issueCausedId === enums.ISSUE.CAUSED.NFPA_70B_VIOLATION) err['nfpa70BViolation'] = { error: true, msg: 'NFPA 70B Violation is required !' }
        if (isEmpty(d.typeOfUltrasonicAnamoly) && d.issueType === enums.ISSUE.TYPE.ULTRASONIC_ANOMALY) err['typeOfUltrasonicAnamoly'] = { error: true, msg: 'Type of Ultrasonic Anamoly is required !' }
        if (!isEmpty(err)) {
          d.error = err
          flagIsseErrors.push(true)
        }
      })
      setIssueDetails(flagIssue)
    }

    if (isValid === true && isEmpty(flagIsseErrors)) submitData('SAVE')
  }
  const submitData = async TYPE => {
    const newObj = {
      isIssueLinkedForFix: get(issueDetails[0], 'isIssueLinkedForFix.value', false),
      thermalClassificationId: get(issueDetails[0], 'thermalClassificationId.value', null),
      thermalAnomalyAdditionalIrPhoto: get(issueDetails[0], 'thermalAnomalyAdditionalIrPhoto', null),
      thermalAnomalyLocation: get(issueDetails[0], 'thermalAnomalyLocation', null),
      thermalAnomalyMeasuredAmps: get(issueDetails[0], 'thermalAnomalyMeasuredAmps', null)?.toString() ?? null,
      thermalAnomalyMeasuredTemps: get(issueDetails[0], 'thermalAnomalyMeasuredTemps', null),
      thermalAnomalyProblemDescription: get(issueDetails[0], 'thermalAnomalyProblemDescription', null),
      thermalAnomalyCorrectiveAction: get(issueDetails[0], 'thermalAnomalyCorrectiveAction', null),
      thermalAnomalyRefrenceTemps: get(issueDetails[0], 'thermalAnomalyRefrenceTemps', null),
      thermalAnomalySubComponant: get(issueDetails[0], 'thermalAnomalySubComponant.value', null),
      thermalAnomalySeverityCriteria: get(issueDetails[0], 'thermalAnomalySeverityCriteria', null),
      necViolation: get(issueDetails[0], 'necViolation.value', null),
      oshaViolation: get(issueDetails[0], 'oshaViolation.value', null),
      nfpa70BViolation: get(issueDetails[0], 'nfpa70BViolation.value', null),
      dynamicFieldJson: JSON.stringify(get(issueDetails[0], 'dynamicFieldJson', null)),
      isAbcPhaseRequiredForReport: get(issueDetails[0], 'isAbcPhaseRequiredForReport', false),
      typeOfUltrasonicAnamoly: get(issueDetails[0], 'typeOfUltrasonicAnamoly.value', null),
      locationOfUltrasonicAnamoly: get(issueDetails[0], 'locationOfUltrasonicAnamoly', ''),
      sizeOfUltrasonicAnamoly: get(issueDetails[0], 'sizeOfUltrasonicAnamoly', ''),
      issueType: get(issueDetails[0], 'issueType', null),
      issueCausedId: get(issueDetails[0], 'issueCausedId', null),
    }

    const payload = createPayload({ issue, isForMaintenance, reason, workOrderID, type: TYPE })
    let data = {}
    try {
      setIsProcessing(TYPE)
      let newPayload = JSON.stringify(snakifyKeys({ ...payload, ...newObj }))
      newPayload = newPayload.replaceAll('nfpa_70_b_violation', 'nfpa_70b_violation')
      const res = isForMaintenance ? await issues.createTempIssue(snakifyKeys(payload)) : await issues.addUpdate(newPayload)
      if (res.success > 0) {
        data = snakifyKeys({ ...res.data, inspectionType: get(issue, 'resolutionType.value', '') })
        Toast.success(`Issue ${isEdit ? 'Updated' : 'Created'} Successfully !`)
      } else Toast.error(res.message || `Error ${isEdit ? 'updating' : 'Creating'} Issue. Please try again !`)
      setIsProcessing('')
    } catch (error) {
      Toast.error(`Error ${isEdit ? 'updating' : 'Creating'} Issue. Please try again !`)
      setIsProcessing('')
    }
    if (TYPE === 'RESOLVE') setResolvedOpen(false)
    if (!isForMaintenance) onClose()
    afterSubmit(data)
  }

  const handleAddIssues = issues => {
    const issueType = get(issues, 'value', null)
    setIssueDetails([
      {
        isIssueLinkedForFix: resolvedOptions[1],
        issueType: issueType === enums.ISSUE.TYPE.NEC_VIOLATION || issueType === enums.ISSUE.TYPE.OSHA_VIOLATION || issueType === enums.ISSUE.TYPE.NFPA_70B_VIOLATION ? enums.ISSUE.TYPE.COMPLIANCE : issueType,
        issueCausedId: issueType === enums.ISSUE.TYPE.NEC_VIOLATION ? enums.ISSUE.CAUSED.NEC_VIOLATION : issueType === enums.ISSUE.TYPE.OSHA_VIOLATION ? enums.ISSUE.CAUSED.OSHA_VIOLATION : issueType === enums.ISSUE.TYPE.NFPA_70B_VIOLATION ? enums.ISSUE.CAUSED.NFPA_70B_VIOLATION : null,
        necViolation: null,
        oshaViolation: null,
        nfpa70BViolation: null,
        thermalAnomalyAdditionalIrPhoto: null,
        thermalAnomalyLocation: null,
        thermalAnomalyMeasuredAmps: null,
        thermalAnomalyMeasuredTemps: null,
        thermalAnomalyProblemDescription: null,
        thermalAnomalyCorrectiveAction: null,
        thermalAnomalyRefrenceTemps: null,
        thermalAnomalySubComponant: null,
        thermalClassificationId: null,
        woLineIssueId: null,
        thermalAnomalySeverityCriteria: null,
        typeOfUltrasonicAnamoly: null,
        locationOfUltrasonicAnamoly: '',
        sizeOfUltrasonicAnamoly: '',
        dynamicFieldJson:
          issueType === enums.ISSUE.TYPE.THERMAL_ANAMOLY
            ? [
                { phase: 'A', circuit: '', current_rating_amp: '', current_draw_amp: '', voltage_drop_millivolts: '' },
                { phase: 'B', circuit: '', current_rating_amp: '', current_draw_amp: '', voltage_drop_millivolts: '' },
                { phase: 'C', circuit: '', current_rating_amp: '', current_draw_amp: '', voltage_drop_millivolts: '' },
                { phase: 'Neutral', circuit: '', current_rating_amp: '', current_draw_amp: '', voltage_drop_millivolts: '' },
              ]
            : null,
        id: 1,
        isAbcPhaseRequiredForReport: false,
      },
    ])
  }

  const difference = function (num1, num2) {
    return Math.abs(num1 - num2)
  }

  const handleMultiIssueChange = (id, value, key) => {
    const updatedIssue = [...issueDetails]
    const currentIssue = updatedIssue.find(d => d.id === id)

    currentIssue[key] = value

    if (key === 'thermalAnomalyMeasuredTemps') {
      if (currentIssue[key] <= 0) {
        currentIssue['thermalAnomalyMeasuredTemps'] = 0
        currentIssue['thermalAnomalyMeasuredAmps'] = difference(0, currentIssue['thermalAnomalyRefrenceTemps'])
      } else {
        currentIssue['thermalAnomalyMeasuredAmps'] = difference(currentIssue['thermalAnomalyMeasuredTemps'], currentIssue['thermalAnomalyRefrenceTemps'])
      }
    } else if (key === 'thermalAnomalyRefrenceTemps') {
      if (currentIssue[key] <= 0) {
        currentIssue['thermalAnomalyRefrenceTemps'] = 0
      }
      currentIssue['thermalAnomalyMeasuredAmps'] = difference(currentIssue['thermalAnomalyMeasuredTemps'], currentIssue['thermalAnomalyRefrenceTemps'])
    }

    setIssueDetails(updatedIssue)
  }

  const handleErrorMultiIssue = (name, id) => {
    const list = [...issueDetails]
    const current = list.find(d => d.id === id)
    if (current) {
      if (!current.error) {
        current.error = {}
      }
      current.error[name] = null
      setIssueDetails(list)
    } else {
      console.error(`No item found with id: ${id}`)
    }
  }

  const handleInputIssueChange = (issueId, value, key) => {
    const [phase, field] = key.split('.')
    setIssueDetails(prevState =>
      prevState.map(issue =>
        issue.id === issueId
          ? {
              ...issue,
              dynamicFieldJson: issue.dynamicFieldJson.map(item => (item.phase === phase ? { ...item, [field]: value } : item)),
            }
          : issue
      )
    )
  }
  //
  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <FormTitle title={title} closeFunc={onClose} style={{ width: '100%', minWidth: '700px' }} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef' }}>
        <div style={{ padding: '10px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
            <MinimalAutoComplete value={get(issue, 'issueType', '') || ''} onChange={value => (handleInputChange('issueType', value), handleAddIssues(value))} error={error.issueType} placeholder='Select type' options={typeOptions} label='Type' isClearable w={100} onFocus={() => setError({ ...error, issueType: null })} isRequired />
            {!isEmpty(issueDetails) && (issueDetails[0].issueType === enums.ISSUE.TYPE.REPAIR || issueDetails[0].issueType === enums.ISSUE.TYPE.REPLACE || issueDetails[0].issueType === enums.ISSUE.TYPE.OTHER) && (
              <MinimalInput value={get(issue, 'issueTitle', '') || ''} onChange={value => handleInputChange('issueTitle', value)} error={error.issueTitle} label='Title' placeholder='Add title' onFocus={() => setError({ ...error, issueTitle: null })} baseStyles={{ marginRight: 0 }} isRequired />
            )}
            {!isEmpty(issueDetails) &&
              issueDetails
                .filter(val => val.issueType === enums.ISSUE.TYPE.THERMAL_ANAMOLY && get(val, 'isDeleted', false) === false)
                .map(d => (
                  <div key={d.id} style={{ width: '640px' }}>
                    <MinimalAutoComplete
                      placeholder='Select Thermal Classification'
                      value={get(d, 'thermalClassificationId', null)}
                      onChange={value => handleMultiIssueChange(d.id, value, 'thermalClassificationId')}
                      options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.THERMAL_CLASSIFICATION}`, thermalClassificationOptions).map(v => ({ ...v, value: parseInt(v.value, 0) }))}
                      label='Thermal Classification'
                      isClearable
                      error={get(d, 'error.thermalClassificationId', '')}
                      onFocus={() => handleErrorMultiIssue('thermalClassificationId', d.id)}
                      baseStyles={{ marginRight: 0 }}
                      w={100}
                      isRequired
                    />
                    <div style={{ display: 'grid', gridTemplateColumns: '50% 50%', gap: '10px' }}>
                      <MinimalInput value={get(d, 'thermalAnomalyLocation', '')} onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalyLocation')} placeholder='Enter Location' label='Issue Location' baseStyles={{ marginRight: 0 }} />
                      <MinimalAutoComplete
                        placeholder="Select Sub-Component (OCP's)"
                        value={get(d, 'thermalAnomalySubComponant', null)}
                        onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalySubComponant')}
                        label="Sub-Component(OCP's)"
                        options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.THERMAL_ANAMOLY_SUBCOMPONENT}`, thermalAnomalySubComponentOptions)}
                        isClearable
                      />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '33% 33% 33%', gap: '8px' }}>
                      <MinimalInput value={get(d, 'thermalAnomalyMeasuredTemps', '')} onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalyMeasuredTemps')} label='Measured Temp.' placeholder='Enter temperature' type='number' min='0' />
                      <MinimalInput value={get(d, 'thermalAnomalyRefrenceTemps', '')} onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalyRefrenceTemps')} label='Reference Temp.' placeholder='Enter temperature' type='number' min='0' />
                      <MinimalInput value={get(d, 'thermalAnomalyMeasuredAmps', '')} onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalyMeasuredAmps')} label='Difference Temp.' placeholder='0' disabled />
                    </div>
                    <MinimalButtonGroup label='Severity Criteria' value={get(d, 'thermalAnomalySeverityCriteria', null)} onChange={value => handleMultiIssueChange(d.id, value, 'thermalAnomalySeverityCriteria')} options={severityCriteriaOptions} w={100} />
                    <MinimalTextArea rows={1} value={get(d, 'thermalAnomalyProblemDescription', '')} onChange={e => handleMultiIssueChange(d.id, e.target.value, 'thermalAnomalyProblemDescription')} label='Problem Description' placeholder='Enter Problem Description' w={100} />
                    <MinimalTextArea rows={1} value={get(d, 'thermalAnomalyCorrectiveAction', '')} onChange={e => handleMultiIssueChange(d.id, e.target.value, 'thermalAnomalyCorrectiveAction')} label='Corrective Action' placeholder='Enter Corrective Action' w={100} />
                    <div className='d-flex justify-content-between align-items-center' style={{ cursor: 'pointer' }}>
                      <div />
                      <div className='d-flex align-items-center'>
                        <div style={{ fontWeight: 400, fontSize: '12px', color: '#BFBFBF' }}>Visible in Report</div>
                        <Checkbox
                          size='small'
                          style={{ padding: 5, color: get(d, 'isAbcPhaseRequiredForReport', false) ? theme.palette.primary.main : theme.palette.primary }}
                          checked={get(d, 'isAbcPhaseRequiredForReport', false)}
                          onChange={value => handleMultiIssueChange(d.id, !get(d, 'isAbcPhaseRequiredForReport', false), 'isAbcPhaseRequiredForReport')}
                        />
                      </div>
                    </div>
                    {/* Phase */}
                    {get(d, 'dynamicFieldJson', []) !== null && (
                      <TableContainer>
                        <Table aria-label='simple table' className={classes.table}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Phase</TableCell>
                              <TableCell align='left'>Circuit #</TableCell>
                              <TableCell align='left'>
                                Current Rating
                                <br /> (AMPS)
                              </TableCell>
                              <TableCell align='left'>
                                Current Draw <br />
                                (AMPS)
                              </TableCell>
                              <TableCell align='left'>
                                Voltage Drop <br />
                                (Millivolts)
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {get(d, 'dynamicFieldJson', [])?.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell component='th' scope='row'>
                                  {item.phase}
                                </TableCell>
                                <TableCell align='center'>
                                  <MinimalInput value={get(d, `dynamicFieldJson[${index}].circuit`, '')} onChange={value => handleInputIssueChange(d.id, value, `${item.phase}.circuit`)} />
                                </TableCell>
                                <TableCell align='left'>
                                  <MinimalInput value={get(d, `dynamicFieldJson[${index}].current_rating_amp`, '')} onChange={value => handleInputIssueChange(d.id, value, `${item.phase}.current_rating_amp`)} />
                                </TableCell>
                                <TableCell align='left'>
                                  <MinimalInput value={get(d, `dynamicFieldJson[${index}].current_draw_amp`, '')} onChange={value => handleInputIssueChange(d.id, value, `${item.phase}.current_draw_amp`)} />
                                </TableCell>
                                <TableCell align='left'>
                                  <MinimalInput value={get(d, `dynamicFieldJson[${index}].voltage_drop_millivolts`, '')} onChange={value => handleInputIssueChange(d.id, value, `${item.phase}.voltage_drop_millivolts`)} />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </div>
                ))}
            {!isEmpty(issueDetails) &&
              issueDetails
                .filter(val => val.issueType === enums.ISSUE.TYPE.ULTRASONIC_ANOMALY && get(val, 'isDeleted', false) === false)
                .map(d => (
                  <div key={d.id}>
                    <MinimalAutoComplete
                      placeholder='Select Type of Anomaly'
                      value={get(d, 'typeOfUltrasonicAnamoly', null)}
                      onChange={value => handleMultiIssueChange(d.id, value, 'typeOfUltrasonicAnamoly')}
                      options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.ULTRASONIC_ANAMOLY}`, UltrasonicAnomalyOptions).map(v => ({ ...v, value: parseInt(v.value, 0) }))}
                      label='Type of Anomaly'
                      isClearable
                      error={get(d, 'error.typeOfUltrasonicAnamoly', '')}
                      onFocus={() => handleErrorMultiIssue('typeOfUltrasonicAnamoly', d.id)}
                      baseStyles={{ marginRight: 0 }}
                      isRequired
                    />
                    <MinimalTextArea rows={3} value={get(d, 'locationOfUltrasonicAnamoly', '') || ''} onChange={e => handleMultiIssueChange(d.id, e.target.value, 'locationOfUltrasonicAnamoly')} placeholder='Enter Location of Anomaly Here ..' label='Location of Anomaly' w={100} />
                    <MinimalInput value={get(d, 'sizeOfUltrasonicAnamoly', '')} onChange={value => handleMultiIssueChange(d.id, value, 'sizeOfUltrasonicAnamoly')} label='Size of Anomaly' placeholder='E.G., 2mm deep, 15mm long' baseStyles={{ marginRight: 0 }} />{' '}
                  </div>
                ))}
            {!isEmpty(issueDetails) &&
              issueDetails
                .filter(val => val.issueType === enums.ISSUE.TYPE.COMPLIANCE && get(val, 'isDeleted', false) === false)
                .filter(c => c.issueCausedId === enums.ISSUE.CAUSED.NEC_VIOLATION)
                .map(d => (
                  <div key={d.id}>
                    <MinimalAutoComplete
                      value={get(d, 'necViolation', null)}
                      error={get(d, 'error.necViolation', '')}
                      onChange={value => handleMultiIssueChange(d.id, value, 'necViolation')}
                      placeholder='Select code'
                      options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NEC_VIOLATION}`, necVoilationOptions).map(v => ({ ...v, value: parseInt(v.value, 0) }))}
                      label='Select Code Violation'
                      isClearable
                      onFocus={() => handleErrorMultiIssue('necViolation', d.id)}
                      baseStyles={{ marginRight: 0 }}
                      isRequired
                    />
                  </div>
                ))}
            {!isEmpty(issueDetails) &&
              issueDetails
                .filter(val => val.issueType === enums.ISSUE.TYPE.COMPLIANCE && get(val, 'isDeleted', false) === false)
                .filter(c => c.issueCausedId === enums.ISSUE.CAUSED.OSHA_VIOLATION)
                .map(d => (
                  <div key={d.id}>
                    <MinimalAutoComplete
                      value={get(d, 'oshaViolation', null)}
                      error={get(d, 'error.oshaViolation', '')}
                      onChange={value => handleMultiIssueChange(d.id, value, 'oshaViolation')}
                      placeholder='Select code'
                      options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.OSHA_VIOLATION}`, oshaVoilationOptions).map(v => ({ ...v, value: parseInt(v.value, 0) }))}
                      label='Select Code Violation'
                      isClearable
                      onFocus={() => handleErrorMultiIssue('oshaViolation', d.id)}
                      baseStyles={{ marginRight: 0 }}
                      isRequired
                    />
                  </div>
                ))}
            {!isEmpty(issueDetails) &&
              issueDetails
                .filter(val => val.issueType === enums.ISSUE.TYPE.COMPLIANCE && get(val, 'isDeleted', false) === false)
                .filter(c => c.issueCausedId === enums.ISSUE.CAUSED.NFPA_70B_VIOLATION)
                .map(d => (
                  <div key={d.id}>
                    <MinimalAutoComplete
                      value={get(d, 'nfpa70BViolation', null)}
                      error={get(d, 'error.nfpa70BViolation', '')}
                      onChange={value => handleMultiIssueChange(d.id, value, 'nfpa70BViolation')}
                      placeholder='Select NFPA 70B'
                      options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NFPA70B_VIOLATION}`, nfpa70bOption).map(v => ({ ...v, value: parseInt(v.value, 0) }))}
                      label='Select NFPA 70B Violation'
                      isClearable
                      onFocus={() => handleErrorMultiIssue('nfpa70BViolation', d.id)}
                      baseStyles={{ marginRight: 0 }}
                      isRequired
                    />
                  </div>
                ))}

            {/* <MinimalAutoComplete
              placeholder='Select a resolution type'
              value={get(issue, 'resolutionType', '') || ''}
              onChange={v => handleInputChange('resolutionType', v)}
              options={inspectionTypes}
              w={100}
              label='Resolution Type'
              error={error.resolutionType}
              onFocus={() => setError({ ...error, resolutionType: null })}
              isClearable
              baseStyles={{ zIndex: '5' }}
              isRequired
            /> */}
            <div className='d-flex'>
              <MinimalAutoComplete
                isLoading={loading}
                value={get(issue, 'asset', '')}
                onChange={v => handleInputChange('asset', v)}
                options={assetOptions}
                label='Linked Asset'
                placeholder='Select Asset'
                w={100}
                isClearable
                onFocus={() => setError({ ...error, asset: null })}
                error={error.asset}
                baseStyles={!isForMaintenance ? { marginRight: 0 } : {}}
                isRequired={!isForMaintenance}
              />
              {/* <FloatingButton onClick={() => install(issue)} icon={<AddIcon fontSize='small' />} style={{ background: theme.palette.primary.main, color: '#fff', width: '42px', height: '42px', marginTop: '18px', borderRadius: '8px' }} /> */}
            </div>
            <MinimalTextArea rows={3} value={get(issue, 'issueDescription', '') || ''} onChange={e => handleInputChange('issueDescription', e.target.value)} placeholder='Add description ..' label='Description' w={100} baseStyles={{ marginBottom: 0 }} />
            <MinimalButtonGroup label='Priority' value={get(issue, 'priority', null)} onChange={value => handleInputChange('priority', value)} options={priorityOptions} w={100} />
            {/* <MinimalTextArea rows={3} value={get(issue, 'backOfficeNote', '') || ''} onChange={e => handleInputChange('backOfficeNote', e.target.value)} placeholder='Add Back Office Note ..' label='Back Office Note' w={100} baseStyles={{ marginBottom: 0 }} /> */}
          </div>
        </div>
        <div style={{ padding: '0 10px' }}>
          <FormAccordian title='Before Photos' style={{ borderRadius: '4px', background: '#fff' }} bg>
            {!isEmpty(error.photos) && photoErrorType === 1 && <div style={{ fontWeight: 800, color: 'red', margin: '10px 16px' }}>{error.photos.msg}</div>}
            <AssetImageUploadButton loading={isPhotoUploading && photoErrorType === 1} disabled={isPhotoUploading} onClick={() => handleUpload(1)} style={{ marginLeft: '15px' }} />
            <input ref={uploadPhotosRef} type='file' style={{ display: 'none' }} onChange={addPhoto} multiple />
            <div className='p-3 mb-2 d-flex' style={{ overflowX: 'auto', whiteSpace: 'nowrap', maxWidth: '450px' }} id='style-1'>
              {get(issue, 'issueImageList', []).map(d => !d.isDeleted && d.imageDurationTypeId === 1 && <AssetImage onRemove={() => removeImage(d)} key={`asset-image-${d.imageFileName}`} url={d.imageFileNameUrl} randomValue />)}
            </div>
          </FormAccordian>
        </div>
        <div style={{ padding: '0 10px', marginTop: '10px' }}>
          <FormAccordian title='After Photos' style={{ borderRadius: '4px', background: '#fff' }} bg>
            {!isEmpty(error.photos) && photoErrorType === 2 && <div style={{ fontWeight: 800, color: 'red', margin: '10px 16px' }}>{error.photos.msg}</div>}
            <AssetImageUploadButton loading={isPhotoUploading && photoErrorType === 2} disabled={isPhotoUploading} onClick={() => handleUpload(2)} style={{ marginLeft: '15px' }} />
            <input ref={uploadPhotosRef} type='file' style={{ display: 'none' }} onChange={addPhoto} multiple />
            <div className='p-3 mb-2 d-flex' style={{ overflowX: 'auto', whiteSpace: 'nowrap', maxWidth: '450px' }} id='style-1'>
              {get(issue, 'issueImageList', []).map(d => !d.isDeleted && d.imageDurationTypeId === 2 && <AssetImage onRemove={() => removeImage(d)} key={`asset-image-${d.imageFileName}`} url={d.imageFileNameUrl} randomValue />)}
            </div>
          </FormAccordian>
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center' style={{ borderTop: '1px solid #A6A6A660', borderBottom: 'none', background: '#fff', marginTop: 'auto', padding: '12px' }}>
        <MinimalButton variant='contained' color='default' text='Cancel' onClick={onClose} />
        <div>
          {isEdit && <MinimalButton variant='contained' color='primary' text='Resolve' onClick={() => setResolvedOpen(true)} baseClassName='mr-2' />}
          <MinimalButton variant='contained' color='primary' text={isEdit ? 'Update' : 'Create'} loadingText={isEdit ? 'Updating...' : 'Creating...'} loading={isProcessing === 'SAVE'} disabled={isProcessing === 'SAVE'} onClick={validateForm} />
        </div>
      </div>
      {isResolveOpen && (
        <PopupModal cta='Resolve' loadingText='Resolving...' open={isResolveOpen} loading={isProcessing === 'RESOLVE'} handleSubmit={() => submitData('RESOLVE')} onClose={() => setResolvedOpen(false)} title='Resolve Issue'>
          <MinimalTextArea rows={3} value={reason} onChange={e => setReason(e.target.value)} placeholder='Please enter reason here..' w={100} />
        </PopupModal>
      )}
    </Drawer>
  )
}

export default Edit
